import { render, staticRenderFns } from "./AddOrganizationPage.vue?vue&type=template&id=d5227420"
import script from "./AddOrganizationPage.vue?vue&type=script&lang=js"
export * from "./AddOrganizationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports